/* global axios */
import ApiClient from '../ApiClient';

class CaptainCatalogItems extends ApiClient {
  constructor() {
    super('captain/catalog_items', { accountScoped: true });
  }

  get({ page = 1, searchKey, itemType } = {}) {
    return axios.get(this.url, {
      params: { page, searchKey, item_type: itemType },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, {
      catalog_item: data,
    });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, {
      catalog_item: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reindex(id) {
    return axios.post(`${this.url}/${id}/reindex`);
  }

  uploadMedia(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${id}/media`, formData);
  }

  deleteMedia(id, attachmentId) {
    return axios.delete(`${this.url}/${id}/media/${attachmentId}`);
  }
}

export default new CaptainCatalogItems();
